import { useRouter } from "../../hooks/router";
import './Cards.scss'
import ErrorImgSubUser from "../Util/img";

import errImgCardMovie from './images/defaultImage.png'
import { useState } from "react";

export default function CardMovies({
    title,
    cardIndex,
    card,
    rowLength,
    content_type,
    row
}) {

    const router = useRouter()

    return (
        
        <div className="main_card_movie" onClick={(content_type == 'lessons' && !row.can_watch ? null : () => router.push(`/movie/${card.id}`))}>

            <div className="img_card_movie">
                <ErrorImgSubUser src={card.poster_tv || card.backdrop} placeholder= {errImgCardMovie}/>
            </div>

            {title === "Continue watching" ?
                <div className="progress_card_movie">
                    <div className="progress_bar_card_movie" style={{ width: card.watched.percent + '%' }}></div>
                </div>
                : null}

            {/* {!card.canWatch ?
                <div className="card_premium_movie">
                    <p>Premium</p>
                </div>
                : null} */}

        </div>
    )
}